import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { RoutesEnum } from '../configuration/enums/routes.enum';
import { SessionStorageService } from '../configuration/services/session-storage.service';
import { TokenService } from '../configuration/services/token.service';
import { TokenLoggedAreaResponse } from '../features/logged-area/auth/models/signin.model';
import { AuthState } from '../features/logged-area/auth/states/auth.state';
import { CacheKeys } from '../services/cache/cache-keys.enum';
import { AppState } from '../store';
import { InterceptorConfigService } from './interceptor-config.service';

@Injectable()
export class AuthorizationInterceptor implements HttpInterceptor {
  constructor(
    private readonly store: Store<AppState>,
    private readonly authState: AuthState,
    private readonly sessionStorageService: SessionStorageService,
    private readonly tokenService: TokenService,
    private readonly interceptorConfig: InterceptorConfigService
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (this.interceptorConfig.isUrlExcluded(request.url) || request.url.endsWith('/authorize'))
      return next.handle(request);

    return next.handle(
      request.clone({
        url: request.url,
        setHeaders: this.getToken(),
      })
    );
  }

  private getToken(): { Authorization: `Bearer ${string}` } {
    let token;
    const URL = window.location.href;
    if (URL.includes(RoutesEnum.LOGGED_AREA)) {
      token = this.authState.currentUser().authInfo?.token;
    } else if (URL.includes(RoutesEnum.PASSWORD_LESS)) {
      token = this.getPasswordlessToken();
    } else {
      token = this.tokenService.getToken() || sessionStorage.getItem('accessToken');
    }

    return {
      Authorization: `Bearer ${token}`,
    };
  }

  private getPasswordlessToken() {
    return this.sessionStorageService.get<TokenLoggedAreaResponse>(CacheKeys.AUTH_PASSWORD_LESS)
      ?.token;
  }
}
